import React, { useState } from "react";
import Footer from "../../components/Footer/Footer";
import HeroSection from "../../components/HeroSection/HeroSection";
import {
  HomeObjMERN,
  HomeObjNode,
  HomeObjMeraki,
  HomeObjCrypto,
  HomeObjIntro,
  HomeObjBlog,
  HomeObjAbout,
  HomeObjMusic,
  HomeObjCollart,
  HomeObjArk,
  HomeObjZephyr,
  HomeObjAarkay,
  HomeObjContact,
} from "../../components/InfoSection/Data";
import InfoSection from "../../components/InfoSection/InfoSection";
import Navbar from "../../components/Navbar/Navbar";
import Sidebar from "../../components/Sidebar/Sidebar";
import About from "../About/About";
import Contact from "../Contact/Contact";
import Pricing from "../Pricing/Pricing";
import Services from "../Services/Services";
import Testimonials from "../Testimonials/Testimonials";
import { HomeContainer } from "./HomeStyle";

const Home = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Navbar toggle={toggle} />

      <HomeContainer>
        <Sidebar isOpen={isOpen} toggle={toggle} />
        <HeroSection />

        {/* Featured Projects */}
        <InfoSection {...HomeObjZephyr} />
        <InfoSection {...HomeObjAarkay} />
        <InfoSection {...HomeObjMERN} />
        <InfoSection {...HomeObjNode} />
        <InfoSection {...HomeObjMeraki} />
        <InfoSection {...HomeObjCollart} />

        {/* Filler */}
        <InfoSection {...HomeObjIntro} />
        <InfoSection {...HomeObjBlog} />
        <About {...HomeObjAbout} />

        {/* Filler End */}

        {/* Other Projects */}
        <InfoSection {...HomeObjArk} />
        <InfoSection {...HomeObjMusic} />
        <InfoSection {...HomeObjCrypto} />

        {/* Contact  */}
        <InfoSection {...HomeObjContact} />

        <Pricing />
        <Services />
        <Testimonials />
        <Contact />
        <Footer />
      </HomeContainer>
    </>
  );
};

export default Home;
